import { PriceInput } from "../ui";

/* eslint-disable no-unused-vars */
export const PriceField = ({ formField, currentPosition, ...props }) => <PriceInput { ...props } type="text" />;